/* Cotiza tu acuario: formula, dibujo en perspectiva y "Agregar al carro".
   Los numeros de la formula vienen del snippet cotiza-acuario-config.liquid (JSON en la seccion).
   La misma formula que el boceto aprobado (Prototipos/cotiza-tu-acuario.html). */
(function () {
  'use strict';

  function leerJSON(root, sel, porDefecto) {
    var el = root.querySelector(sel);
    if (!el) return porDefecto;
    try { return JSON.parse(el.textContent); } catch (e) { return porDefecto; }
  }

  /* ---------------- Formula (identica al boceto) ---------------- */
  function redondeaArriba(x, paso) {
    return Math.ceil(Math.round(x * 100) / 100 / paso) * paso;
  }

  function hacerCalculadora(c) {
    function calcular(L, A, P) {
      var r = { L: L, A: A, P: P, motivo: '' };
      if (A > c.reglas.altoMaxSobreFondo * P) {
        r.motivo = 'El alto no puede pasar del doble del fondo.';
      } else if (P > c.reglas.fondoMaxSobreLargo * L) {
        r.motivo = 'El fondo no puede ser mayor que el largo.';
      }
      r.valido = r.motivo === '';

      var g = null;
      for (var i = 0; i < c.grosores.length; i++) {
        var x = c.grosores[i];
        if (L <= x.largoHasta && P <= x.fondoHasta && A <= x.altoHasta) { g = x; break; }
      }
      if (!g) {
        g = c.grosores[c.grosores.length - 1];
        if (r.valido) { r.motivo = 'Esa medida pasa lo que fabricamos.'; r.valido = false; }
      }
      r.mm = g.mm;

      r.area = (L * P + 2 * L * A + 2 * P * A) / 10000;
      r.pM2 = c.precioM2[r.mm];
      r.vidrio = r.area * r.pM2;
      r.cmLargo = Math.max(0, L - c.largoLargo.sobreCm);
      r.extraLargo = r.cmLargo * c.largoLargo.porCm;
      r.listaCalc = c.fijo + r.vidrio + r.extraLargo;
      r.minimo = c.minimoPorGrosor[r.mm] || 0;
      r.lista = Math.max(r.listaCalc, r.minimo);
      r.precioN = redondeaArriba(r.lista * (1 + c.recargoAMedida), c.redondeo);

      r.nTir = 0;
      for (var j = 0; j < c.tirantes.length; j++) {
        if (L >= c.tirantes[j].desdeCm) { r.nTir = c.tirantes[j].cantidad; break; }
      }

      r.areaTapa = (L * P) / 10000;
      r.extraTapa = redondeaArriba(r.areaTapa * c.tapa.precioM2 * c.tapa.multiplicador, c.redondeo);

      r.litros = L * A * P / 1000;
      r.peso = Math.round((r.litros + r.area * r.mm * c.kgPorM2PorMm) / c.pesoRedondeo) * c.pesoRedondeo;
      return r;
    }
    return calcular;
  }

  function totalDe(r, tapa) { return r.precioN + (tapa ? r.extraTapa : 0); }

  function pesos(n) {
    var s = String(Math.round(n));
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function miles(n) {
    return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  /* FILTRO-INICIO (S4, 26-oct-2026). Regla de las guias: el filtro mueve por lo menos 5 veces los litros por hora.
     Se parte del bloque que toca por largo (como antes) y se sube al siguiente hasta que su caudal alcance:
     caudal >= 5 x litros  <=>  caudal x 200 >= largo x alto x fondo. Caudal 0 = no se mira. Si ninguno alcanza,
     se devuelve el ultimo con suficiente = false. Scripts/paginas-medida.py revisar prueba esta funcion con node. */
  function elegirFiltro(filtros, L, A, P) {
    var i = 0;
    while (i < filtros.length - 1 && L > filtros[i].hastaCm) i++;
    for (var j = i; j < filtros.length; j++) {
      if (!(filtros[j].caudal > 0) || filtros[j].caudal * 200 >= L * A * P) return { f: filtros[j], suficiente: true };
    }
    return { f: filtros[filtros.length - 1], suficiente: false };
  }
  /* FILTRO-FIN */

  /* ---------------- Una instancia por seccion ---------------- */
  function iniciar(root) {
    var CONFIG = leerJSON(root, '[data-cotiza-config]', null);
    if (!CONFIG) return;
    var VARIANTES = leerJSON(root, '[data-cotiza-variantes]', null) || {};
    var FILTROS = leerJSON(root, '[data-cotiza-filtros]', []).filter(function (f) { return f.hastaCm > 0; });
    FILTROS.sort(function (a, b) { return a.hastaCm - b.hastaCm; });
    var calcular = hacerCalculadora(CONFIG);

    var $ = function (n) { return root.querySelector('[data-cz="' + n + '"]'); };
    var $d = function (n) { return root.querySelector('[data-d="' + n + '"]'); };
    var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

    /* Dibujo en perspectiva */
    var DIB = { ancho: 400, suelo: 182, anchoUtil: 286, escalaBase: 2.0, kx: 0.476, ky: 0.275, aristaMin: 1.3, aristaMax: 4.6 };
    function P2(a) { return a[0].toFixed(1) + ',' + a[1].toFixed(1); }
    function poly(id, pts) { $d(id).setAttribute('points', pts.map(P2).join(' ')); }
    function lerp(a, b, t) { return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t]; }
    function mas(a, b) { return [a[0] + b[0], a[1] + b[1]]; }
    var tirCant = 0;

    function dibujar(L, A, P, mm) {
      var k = Math.min(DIB.escalaBase, DIB.anchoUtil / (L + DIB.kx * P));
      var Ls = L * k, As = A * k, dx = P * k * DIB.kx, dy = P * k * DIB.ky;
      var x0 = DIB.ancho / 2 - (Ls + dx) / 2, y0 = DIB.suelo;
      var ew = DIB.aristaMin + (Math.min(Math.max(mm, 4), 19) - 4) / 15 * (DIB.aristaMax - DIB.aristaMin);

      var off = [dx, -dy];
      var FBL = [x0, y0], FBR = [x0 + Ls, y0], FTL = [x0, y0 - As], FTR = [x0 + Ls, y0 - As];
      var BBL = mas(FBL, off), BBR = mas(FBR, off), BTL = mas(FTL, off), BTR = mas(FTR, off);
      var hw = Math.min(A * 0.9, A - 3) * k;
      var FWL = [x0, y0 - hw], FWR = [x0 + Ls, y0 - hw];
      var BWL = mas(FWL, off), BWR = mas(FWR, off);

      poly('sombra', [[x0 - 5, y0 + 5], [x0 + Ls + 5, y0 + 5], [BBR[0] + 6, BBR[1] + 4], [BBL[0] - 2, BBL[1] + 4]]);
      poly('suelo', [FBL, FBR, BBR, BBL]);
      poly('vfondo', [BBL, BBR, BTR, BTL]);
      poly('afondo', [BBL, BBR, BWR, BWL]);
      poly('aizq', [FBL, BBL, BWL, FWL]);
      poly('afrente', [FBL, FBR, FWR, FWL]);
      poly('ader', [FBR, BBR, BWR, FWR]);
      poly('vlado', [FBR, BBR, BTR, FTR]);
      poly('vfrente', [FBL, FBR, FTR, FTL]);
      poly('asup', [FWL, FWR, BWR, BWL]);

      function sp(u, v) { return [FWL[0] + u * Ls + v * dx, FWL[1] - v * dy]; }
      poly('br1', [sp(.07, .2), sp(.42, .2), sp(.46, .34), sp(.11, .34)]);
      poly('br2', [sp(.58, .58), sp(.74, .58), sp(.77, .68), sp(.61, .68)]);
      poly('fr1', [[x0 + Ls * .09, y0], [x0 + Ls * .15, y0], [x0 + Ls * .33, y0 - As], [x0 + Ls * .27, y0 - As]]);
      poly('fr2', [[x0 + Ls * .19, y0], [x0 + Ls * .215, y0], [x0 + Ls * .395, y0 - As], [x0 + Ls * .37, y0 - As]]);

      var tw = Math.max(3.5, 4 * k);
      var fr = tirCant === 1 ? [0.5] : (tirCant === 2 ? [1 / 3, 2 / 3] : []);
      for (var i = 1; i <= 2; i++) {
        var e = $d('tir' + i), f = fr[i - 1];
        if (f === undefined) { e.classList.remove('on'); continue; }
        var xa = x0 + f * Ls;
        e.setAttribute('points', [[xa - tw / 2, FTL[1]], [xa + tw / 2, FTL[1]], [xa + tw / 2 + dx, FTL[1] - dy], [xa - tw / 2 + dx, FTL[1] - dy]].map(P2).join(' '));
        e.setAttribute('stroke-width', (ew * 0.35 + 0.5).toFixed(2));
        e.classList.add('on');
      }
      poly('tapa', [FTL, FTR, BTR, BTL]);

      $d('arista').setAttribute('stroke-width', ew.toFixed(2));
      $d('arista').setAttribute('d',
        'M' + P2(FBL) + 'L' + P2(FBR) + 'L' + P2(FTR) + 'L' + P2(FTL) + 'Z' +
        'M' + P2(FBR) + 'L' + P2(BBR) + 'L' + P2(BTR) + 'L' + P2(FTR) +
        'M' + P2(FTL) + 'L' + P2(BTL) + 'L' + P2(BTR));
      $d('atras').setAttribute('stroke-width', (ew * 0.7).toFixed(2));
      $d('atras').setAttribute('d', 'M' + P2(FBL) + 'L' + P2(BBL) + 'L' + P2(BBR) + 'M' + P2(BBL) + 'L' + P2(BTL));

      var yc = y0 + 17;
      $d('c-largo').setAttribute('d', 'M' + x0.toFixed(1) + ',' + yc + 'L' + (x0 + Ls).toFixed(1) + ',' + yc +
        'M' + x0.toFixed(1) + ',' + (yc - 4) + 'L' + x0.toFixed(1) + ',' + (yc + 4) +
        'M' + (x0 + Ls).toFixed(1) + ',' + (yc - 4) + 'L' + (x0 + Ls).toFixed(1) + ',' + (yc + 4));
      var tl = $d('t-largo');
      tl.setAttribute('x', (x0 + Ls / 2).toFixed(1)); tl.setAttribute('y', yc + 15);
      tl.textContent = Math.round(L) + ' cm';

      var xc = x0 - 11;
      $d('c-alto').setAttribute('d', 'M' + xc.toFixed(1) + ',' + y0 + 'L' + xc.toFixed(1) + ',' + (y0 - As).toFixed(1) +
        'M' + (xc - 4).toFixed(1) + ',' + y0 + 'L' + (xc + 4).toFixed(1) + ',' + y0 +
        'M' + (xc - 4).toFixed(1) + ',' + (y0 - As).toFixed(1) + 'L' + (xc + 4).toFixed(1) + ',' + (y0 - As).toFixed(1));
      var ta = $d('t-alto');
      ta.setAttribute('x', (xc - 6).toFixed(1)); ta.setAttribute('y', (y0 - As / 2 + 5).toFixed(1));
      ta.textContent = Math.round(A) + ' cm';

      var o = [10, 7];
      var s1 = mas(FBR, o), s2 = mas(BBR, o);
      $d('c-fondo').setAttribute('d', 'M' + P2(s1) + 'L' + P2(s2) +
        'M' + (s1[0] - 4).toFixed(1) + ',' + s1[1].toFixed(1) + 'L' + (s1[0] + 4).toFixed(1) + ',' + s1[1].toFixed(1) +
        'M' + (s2[0] - 4).toFixed(1) + ',' + s2[1].toFixed(1) + 'L' + (s2[0] + 4).toFixed(1) + ',' + s2[1].toFixed(1));
      var tf = $d('t-fondo');
      var mid = lerp(s1, s2, 0.5);
      tf.setAttribute('x', (mid[0] + 7).toFixed(1)); tf.setAttribute('y', (mid[1] + 5).toFixed(1));
      tf.textContent = Math.round(P) + ' cm';
    }

    /* Animacion suave: dibujo y precio persiguen al valor objetivo */
    var cur = { L: 0, A: 0, P: 0, mm: 6, pr: 0 };
    var tgt = { L: 0, A: 0, P: 0, mm: 6, pr: 0 };
    var raf = 0, ultimo = 0;
    function pintaPrecio(v) { $('precio').textContent = pesos(Math.round(v / 1000) * 1000); }
    function pintaTodo() {
      dibujar(cur.L, cur.A, cur.P, cur.mm);
      if (!$('precio-bloque').hidden) pintaPrecio(cur.pr);
    }
    function paso(ts) {
      var dt = Math.min(48, ts - (ultimo || ts - 16));
      ultimo = ts;
      var a = 1 - Math.exp(-dt / 65);
      var moviendo = false;
      ['L', 'A', 'P', 'mm', 'pr'].forEach(function (key) {
        var d = tgt[key] - cur[key];
        var eps = key === 'pr' ? 400 : 0.03;
        if (Math.abs(d) < eps) { cur[key] = tgt[key]; } else { cur[key] += d * a; moviendo = true; }
      });
      pintaTodo();
      if (moviendo) { raf = requestAnimationFrame(paso); } else { raf = 0; ultimo = 0; }
    }
    function mover(instante) {
      if (instante || reduce.matches) {
        cur.L = tgt.L; cur.A = tgt.A; cur.P = tgt.P; cur.mm = tgt.mm; cur.pr = tgt.pr;
        pintaTodo();
        return;
      }
      if (!raf) { ultimo = 0; raf = requestAnimationFrame(paso); }
    }

    /* Estado y pantalla */
    var rL = $('r-largo'), rA = $('r-alto'), rP = $('r-fondo');
    var cEx = $('c-exacta'), cTapa = $('c-tapa');
    var ultimoMm = null, ultimoFiltro = -1, anuncioT = 0;
    var estado = null;
    var pedidoFuera = false;   // el link traia una medida fuera de lo que fabricamos: se avisa hasta que el cliente mueva algo

    function snap5(el) {
      var v = Math.round(Number(el.value) / 5) * 5;
      el.value = String(Math.min(Number(el.max), Math.max(Number(el.min), v)));
    }
    function relleno(el) {
      var p = (Number(el.value) - Number(el.min)) / (Number(el.max) - Number(el.min)) * 100;
      el.style.setProperty('--p', p.toFixed(1) + '%');
      el.setAttribute('aria-valuetext', el.value + ' centímetros');
    }
    function ocultarError() { var e = $('error'); e.hidden = true; e.textContent = ''; }

    function render(inicial) {
      var L = Number(rL.value), A = Number(rA.value), P = Number(rP.value);
      var r = calcular(L, A, P);
      if (pedidoFuera) { r.valido = false; r.motivo = 'Esa medida pasa lo que fabricamos.'; }
      estado = r;
      var total = totalDe(r, cTapa.checked);

      [rL, rA, rP].forEach(relleno);
      $('o-largo').textContent = L + ' cm';
      $('o-alto').textContent = A + ' cm';
      $('o-fondo').textContent = P + ' cm';

      tirCant = r.nTir;
      tgt.L = L; tgt.A = A; tgt.P = P; tgt.mm = r.mm;
      if (r.valido) tgt.pr = total;
      $('escena').classList.toggle('cz-fuera', !r.valido);
      $('dibujo').setAttribute('aria-label', 'Acuario de ' + L + ' cm de largo, ' + A + ' cm de alto y ' + P + ' cm de fondo');
      $d('tapa').classList.toggle('on', cTapa.checked);

      $('s-litros').textContent = String(Math.round(r.litros));
      $('s-mm').textContent = r.mm + ' mm';
      $('s-kg').textContent = r.peso + ' kg';
      if (ultimoMm !== null && r.mm > ultimoMm && !reduce.matches) {
        var d = $('d-grosor');
        d.classList.remove('cz-destello'); void d.offsetWidth; d.classList.add('cz-destello');
      }
      ultimoMm = r.mm;

      $('precio-bloque').hidden = !r.valido;
      $('aviso').hidden = r.valido;
      $('n-motivo').textContent = r.motivo ? r.motivo + ' Pruebe con otra medida.' : '';
      $('btn-pedir').disabled = !r.valido;
      if (!inicial) ocultarError();

      $('p-tapa').textContent = r.valido ? (r.extraTapa > 0 ? '+ ' + pesos(r.extraTapa) : 'Gratis') : '';
      $('n-grosor').textContent = r.mm > 5
        ? 'Con estas medidas el vidrio sube a ' + r.mm + ' mm. Por eso cambia el precio.'
        : '';
      $('n-peso').textContent = 'Lleno pesa unos ' + r.peso + ' kg. Póngalo sobre un mueble firme y nivelado.';

      if (FILTROS.length && $('filtro')) {
        var el = elegirFiltro(FILTROS, L, A, P);
        var f = el.f;
        if (f.hastaCm !== ultimoFiltro) {
          ultimoFiltro = f.hastaCm;
          var img = $('f-img');
          if (f.img) { img.src = f.img; img.alt = f.nombre; img.hidden = false; } else { img.hidden = true; }
          $('f-nom').textContent = f.nombre;
          $('f-pre').textContent = f.precio;
          if (f.url) $('f-link').href = f.url;
        }
        var necesita = Math.round(r.litros * 5);
        var titFiltro = root.querySelector('.cz-filtro .cz-h3');
        if (titFiltro) titFiltro.textContent = el.suficiente ? 'Filtro que le sirve' : 'Filtro de partida';
        if (!el.suficiente) {
          $('f-nota').textContent = 'Para este tamaño conviene un filtro externo más grande que este: escríbanos por Instagram. Es una sugerencia, no se suma al precio.';
        } else if (f.caudal > 0) {
          $('f-nota').textContent = 'Mueve ' + miles(f.caudal) + ' litros por hora y su acuario pide unos ' + miles(necesita) + ' (5 veces el agua por hora). Es una sugerencia, no se suma al precio.';
        } else {
          $('f-nota').textContent = 'Sirve para acuarios de hasta ' + f.hastaCm + ' cm de largo. Es una sugerencia, no se suma al precio.';
        }
      }

      mover(inicial);

      clearTimeout(anuncioT);
      if (!inicial) {
        anuncioT = setTimeout(function () {
          $('anuncio').textContent = r.valido
            ? 'Acuario de ' + L + ' por ' + A + ' por ' + P + ' centímetros. Precio ' + pesos(total) + '.'
            : 'Para esta medida escríbanos por Instagram y lo vemos.';
        }, 700);
      }
    }

    /* Agregar al carro: la variante cuyo precio es el calculado */
    function variantePara(total) {
      if (VARIANTES.ids && typeof VARIANTES.desde === 'number') {
        var i = Math.round((total - VARIANTES.desde) / (VARIANTES.paso || 1000));
        return i >= 0 && i < VARIANTES.ids.length ? VARIANTES.ids[i] : null;
      }
      return VARIANTES[String(total)] || null;
    }

    function mostrarError(msg) {
      var e = $('error');
      e.textContent = msg;
      e.hidden = false;
    }

    function agregarAlCarro() {
      var r = estado;
      if (!r || !r.valido) return;
      var btn = $('btn-pedir');
      var total = totalDe(r, cTapa.checked);
      var id = variantePara(total);
      ocultarError();
      if (root.getAttribute('data-producto-listo') !== 'si') {
        mostrarError('Vista previa: el producto "Acuario a medida" todavía no está activo en la tienda, por eso no se puede agregar al carro. Cuando se active, este botón lleva al carro con las medidas anotadas.');
        return;
      }
      if (!id) {
        mostrarError('No encontramos el precio ' + pesos(total) + ' en la tienda. Escríbanos por Instagram y lo vemos.');
        return;
      }
      var textoOriginal = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Agregando…';
      var cuerpo = {
        items: [{
          id: id,
          quantity: 1,
          properties: {
            'Largo': r.L + ' cm',
            'Fondo': r.P + ' cm',
            'Alto': r.A + ' cm',
            'Litros': String(Math.round(r.litros)),
            'Vidrio': r.mm + ' mm',
            'Tapa': cTapa.checked ? (r.extraTapa > 0 ? 'Sí (+' + pesos(r.extraTapa) + ')' : 'Sí (gratis)') : 'No'
          }
        }]
      };
      fetch(root.getAttribute('data-cart-add') || '/cart/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(cuerpo)
      }).then(function (res) {
        return res.json().then(function (j) { return { ok: res.ok, j: j }; });
      }).then(function (x) {
        if (!x.ok) throw new Error(x.j && (x.j.description || x.j.message) || 'No se pudo agregar.');
        window.location.href = root.getAttribute('data-cart') || '/cart';
      }).catch(function (err) {
        btn.disabled = false;
        btn.textContent = textoOriginal;
        mostrarError('No pudimos agregar el acuario al carro (' + (err && err.message ? err.message : 'error') + '). Inténtelo de nuevo o escríbanos por Instagram.');
      });
    }

    $('btn-pedir').addEventListener('click', agregarAlCarro);

    [rL, rA, rP].forEach(function (el) { el.addEventListener('input', function () { pedidoFuera = false; render(false); guardarURL(); }); });
    cTapa.addEventListener('change', function () { pedidoFuera = false; render(false); guardarURL(); });
    $('medidas').addEventListener('submit', function (ev) { ev.preventDefault(); });

    function aplicarPaso() {
      var st = cEx.checked ? CONFIG.paso.exacto : CONFIG.paso.normal;
      [rL, rA, rP].forEach(function (el) {
        el.step = String(st);
        if (!cEx.checked) snap5(el);
      });
    }
    cEx.addEventListener('change', function () { pedidoFuera = false; aplicarPaso(); render(false); guardarURL(); });

    /* Partida */
    var lim = CONFIG.limites;
    [[rL, lim.largo, CONFIG.inicio.largo], [rA, lim.alto, CONFIG.inicio.alto], [rP, lim.fondo, CONFIG.inicio.fondo]].forEach(function (x) {
      x[0].min = String(x[1].min); x[0].max = String(x[1].max); x[0].step = String(CONFIG.paso.normal); x[0].value = String(x[2]);
    });
    render(true);

    /* Medida en el link: ?largo=150&alto=50&fondo=40&tapa=1#cotiza (todo opcional).
       La usan el link de entrada y el boton "Cotizar esta medida" de las tarjetas. */
    var NOMBRES = ['largo', 'alto', 'fondo'];
    var QUERY_INICIAL = (function () { try { return new URLSearchParams(window.location.search); } catch (e) { return null; } })();
    var hayParamsInicial = false;
    function entero(v) {
      if (v === null || v === undefined || !/^\s*\d+\s*$/.test(String(v))) return null;
      var n = parseInt(v, 10);
      return n > 0 ? n : null;
    }
    function leerMedida(q) {
      if (!q) return null;
      var m = { largo: entero(q.get('largo')), alto: entero(q.get('alto')), fondo: entero(q.get('fondo')), tapa: q.has('tapa') ? q.get('tapa') === '1' : null };
      return (m.largo !== null || m.alto !== null || m.fondo !== null || m.tapa !== null) ? m : null;
    }
    function cargarMedida(m, instante) {
      var barras = { largo: rL, alto: rA, fondo: rP };
      pedidoFuera = false;
      // 1) si alguna no cae en el paso de 5 cm (desde el minimo de su barra), se activa "Medida exacta"
      var noCalza = NOMBRES.some(function (k) {
        var v = m[k];
        return v !== null && v !== undefined && (v - Number(barras[k].min)) % CONFIG.paso.normal !== 0;
      });
      if (noCalza) cEx.checked = true;
      aplicarPaso();
      // 2) valores: dentro del rango van tal cual; fuera de rango la barra queda en el tope y se muestra el aviso
      NOMBRES.forEach(function (k) {
        var v = m[k];
        if (v === null || v === undefined) return;
        var el = barras[k];
        if (v < Number(el.min) || v > Number(el.max)) pedidoFuera = true;
        el.value = String(Math.min(Number(el.max), Math.max(Number(el.min), v)));
      });
      if (m.tapa !== null && m.tapa !== undefined) cTapa.checked = !!m.tapa;
      render(!!instante);
    }

    /* La URL sigue a las barras (para copiar el link de la medida). Sin tocar nada, no se ensucia. */
    var urlT = 0;
    function guardarURL() {
      clearTimeout(urlT);
      urlT = setTimeout(function () {
        try {
          var enInicio = Number(rL.value) === CONFIG.inicio.largo && Number(rA.value) === CONFIG.inicio.alto &&
                         Number(rP.value) === CONFIG.inicio.fondo && !cTapa.checked;
          if (enInicio && !hayParamsInicial) return;
          var q = new URLSearchParams(window.location.search);
          q.set('largo', rL.value); q.set('alto', rA.value); q.set('fondo', rP.value);
          if (cTapa.checked) q.set('tapa', '1'); else q.delete('tapa');
          history.replaceState(null, '', window.location.pathname + '?' + q.toString() + '#cotiza');
          hayParamsInicial = true;
        } catch (e) { /* sin historial (vista previa, iframe): no pasa nada */ }
      }, 250);
    }

    var yaInteractuo = false;
    ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(function (ev) {
      window.addEventListener(ev, function () { yaInteractuo = true; }, { passive: true, once: true });
    });
    function irAlCotizador(suave) {
      root.scrollIntoView({ behavior: suave && !reduce.matches ? 'smooth' : 'auto', block: 'start' });
    }

    var delLink = leerMedida(QUERY_INICIAL);
    if (delLink) {
      hayParamsInicial = true;
      cargarMedida(delLink, true);
    } else if (root.getAttribute('data-cz-inicio')) {
      /* Pagina por medida (data-cz-inicio="largo,alto,fondo,tapa"): abre con esa medida, sin mover la pagina. */
      var ini = root.getAttribute('data-cz-inicio').split(',').map(Number);
      if (ini.length === 4 && !ini.some(isNaN)) cargarMedida({ largo: ini[0], alto: ini[1], fondo: ini[2], tapa: ini[3] === 1 }, true);
    }
    if (delLink || window.location.hash === '#cotiza') {
      irAlCotizador(false);
      // las fotos de abajo/arriba pueden mover el layout: se vuelve a alinear una vez, si el cliente aun no toco nada
      window.addEventListener('load', function () { if (!yaInteractuo) irAlCotizador(false); });
    }

    /* Tarjetas "Que acuario necesita su pez": el boton lleva la medida a las barras y sube al cotizador.
       Es un link real (/pages/acuarios-a-medida?largo=..#cotiza): sin JS igual abre la pagina con la medida. */
    function enlazarMedida(a) {
      a.addEventListener('click', function (ev) {
        if (ev.defaultPrevented || ev.button > 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
        var m = (a.getAttribute('data-cz-medida') || '').split(',').map(Number);
        if (m.length !== 3 || m.some(isNaN)) return;
        ev.preventDefault();
        cargarMedida({ largo: m[0], alto: m[1], fondo: m[2], tapa: a.getAttribute('data-cz-tapa') === '1' });
        guardarURL();
        irAlCotizador(true);
      });
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-cz-medida]'), enlazarMedida);
    /* Paginas por medida: los botones "Cargar esta medida" estan en otra seccion de la pagina (data-cz-externo).
       Con JS cargan la medida aqui mismo; sin JS son links normales con ?largo=..#cotiza. */
    Array.prototype.forEach.call(document.querySelectorAll('[data-cz-externo][data-cz-medida]'), function (a) {
      if (!a.czEnlazado) { a.czEnlazado = true; enlazarMedida(a); }
    });

    /* Para revisar la formula desde la consola */
    root.cotizaAcuario = { calcular: calcular, totalDe: totalDe, config: CONFIG, variantes: VARIANTES };
  }

  function arrancar() {
    var roots = document.querySelectorAll('[data-cotiza]');
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i].cotizaAcuario) iniciar(roots[i]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
  document.addEventListener('shopify:section:load', arrancar);
})();
